"use client";
import React from "react";
import styles from "./Benefits.mobile.module.scss";

const ShowMore = ({ data, showMore, handleClick }) => {
  if (data.benefits_info.length > 3) {
    return (
      <div className={styles.showmore} onClick={handleClick}>
        <span>{!showMore ? data.more_text : data.less_text}</span>
        <svg
          className={Boolean(showMore) && styles.arrowUp}
          xmlns='http://www.w3.org/2000/svg'
          width='14'
          height='14'
          viewBox='0 0 14 14'
          fill='none'
        >
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M11.5148 4.55934C11.7172 4.76184 11.7172 5.09014 11.5148 5.29264L7.36661 9.44078C7.16411 9.64328 6.8358 9.64328 6.63331 9.44078L2.48516 5.29264C2.28267 5.09014 2.28267 4.76183 2.48516 4.55934C2.68766 4.35685 3.01596 4.35685 3.21846 4.55934L6.99996 8.34084L10.7815 4.55934C10.984 4.35685 11.3123 4.35685 11.5148 4.55934Z'
            fill='#7D7D7D'
          />
        </svg>
      </div>
    );
  }
  return null;
};

export default ShowMore;
